import axios from 'axios';
import { isTestMode } from './network';

// Use environment variable for production, fallback to /api for development (proxy)
// On Vercel, API routes are served from the same domain, so /api works for both
const baseURL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL,
});

// IMPORTANT:
// On Vercel, the serverless rewrite normalizes req.url and can drop extra query params.
// So we propagate "?test=true" as a header that the backend can reliably read.
api.interceptors.request.use((config) => {
  if (isTestMode()) {
    config.headers = config.headers || {};
    config.headers['x-app-network'] = 'test';
  }
  return config;
});

export default api;
